<script lang="ts">
    import { NEWSLETTER_CARTO, NEWSLETTER_PARTNER } from "../scripts/constant";


    import {
        redirectTo,
        historyNavigation,
        storeCurRoute,
    } from "../scripts/router1";
    import {
        idPageHome,
        idPageDecouvrir,
        idPageAccompagner,
        idPageActualites,
        idPageContacts,
        idPageMentionsLegales,
        namePageDecouvrir,
        namePageAccompagner,
        namePageActualites,
        idPageProjets,
        idPageCharte,
        idPageBudget2025,
    } from "../scripts/router2";
    import { 
        storeIsOpenNewsletterRegistration,
        storeNewsletterRegistrationText, 
        storeNewsletterRegistrationTitle, 
        storeNewsletterRegistrationImage 
    } from "../scripts/store";

    let isOpenBurger: boolean = false;
    let isSubMenuClicked: boolean = false;
    let isHoverLogoTitle: boolean = false;

    function burgerToggle() {
        if (getComputedStyle(document.getElementById("id_burger")!).display != "none") {
            isOpenBurger = !isOpenBurger;
            document.getElementsByClassName("navigation")[0].scrollTo(0,0);
        }
    }

    function hideSubMenu(): void {
        isSubMenuClicked = true;
        setTimeout(() => {isSubMenuClicked = false}, 1000);
    }

        /**
     * selectMenu
     * @param menuSelected
     */
     function selectMenu(menuSelected: string, tempo: number = 0) {
        if (tempo > 0) {
            // launchLoader(tempo);
        }
        setTimeout(() => redirectTo(menuSelected), tempo);
        hideSubMenu();
    }

    let previousTop: number = 100000;
    let decreaseMenu: boolean = false;
    const startDecrease: number = 500;

    /**
     * Détection du sens du scroll
     * Si vers le haut alors afficher le sous-menu
     * Si vers le bas alors masquer le sous-menu
     */
     function expandDecrease() {
        var currentTop = window.scrollY;
        if (currentTop < previousTop) {
            // go up
            decreaseMenu = false;
        } else if (currentTop > startDecrease) {
            // go down
            decreaseMenu = true;
        }
        previousTop = currentTop;
    }

    function toggleHoverLogoTitle() {
        isHoverLogoTitle = !isHoverLogoTitle;
    }

    function clickTitle() {
        redirectTo(idPageHome);
        if (isOpenBurger) {
            burgerToggle();
        }
    }

    function openCarto() {
		storeNewsletterRegistrationTitle.set("en&nbsp;construction");
		storeNewsletterRegistrationText.set("La cartographie des PTCE est en cours de construction et sera disponible dans les prochains mois.<br>N’hésitez pas à vous abonner à notre newsletter pour ne rater aucune de nos actualités");
		storeIsOpenNewsletterRegistration.set(true);
        storeNewsletterRegistrationImage.set(NEWSLETTER_CARTO);
	}
    
</script>
  
  
<style lang="scss">

    $color_navigation_bg: $color-white;
    $color_navigation: $color-primary;
    $color_menu_item: white;
    $color_menu_item_hover: #006600;
    $color_menu_item_active: red;

    /* burger 2 lignes*/

    $burger2_size_a: 6px;
    $burger2_size_b: 2px;
    $burger2_size_V: 30px;
    $burger2_size_c: 9px;
    $burger2_size_d: 29px;
    $burger2_size_H: 47px;
    $burger2_size_top_tY: 4px;
    $burger2_size_bottom_tY: -4px;

    .burger2 {
        position: fixed;
        top: 18px;
        right: 30px;
        height: $burger2_size_H;
        width: $burger2_size_V;
        cursor: pointer;
        z-index: 1000;
        &__lineTop, &__lineBottom {
            height: $burger2_size_b;
            width: $burger2_size_d;
            margin: $burger2_size_a $burger2_size_c;
            background-color: $color_black;
            transition: 0.4s;
        }
        &__lineTop--open {
            height: $burger2_size_b;
            width: $burger2_size_d;
            margin: $burger2_size_a $burger2_size_c;
            background-color: $color_black;
            transition: 0.4s;
            transform: translateY($burger2_size_top_tY) rotate(-25deg);    
        }
        &__lineBottom--open {
            height: $burger2_size_b;
            width: $burger2_size_d;
            margin: $burger2_size_a $burger2_size_c;
            background-color: $color_black;
            transition: 0.4s;
            transform: translateY($burger2_size_bottom_tY) rotate(25deg);
        }
    }

    .navleft {
        position: fixed;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0 0 20px;
    }

	.logo {
        display: none;
    }

    .title {
        font-family: 'Borna-Bold';
        font-size: 15px;
        color: $color_black;
    }

    .navbottom {
        display: none;
    }

    .navsocial {
        display: none;
    }

    .navmobile {
        background-color: $color_white;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 0 0 0 20px;
        margin: 50px 0 0 0;
    }

    .navbottom-mobile {
        margin-top: -15px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        font-family: 'Borna-Medium';
        font-size: 19px;
        &__link {
            text-decoration: none;
            color: black;
        }
        &__square {
            height: 40px;
            cursor: pointer;
            padding: 0px 10px 0px 10px;
            margin: 0 0 20px 0;
            background-color: $color_white;
            border: 1px solid $color_black;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &:hover {
                background-color: $color_primary;
            }
        }
        &__round {
            height: 40px;
            border-radius: 15px; // 1/2 height
            cursor: pointer;
            padding: 0px 10px 0px 10px;
            margin: 0 0 20px 0;
            background-color: $color_white;
            border: 1px solid $color_black;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &:hover {
                background-color: $color_primary;
            }
            &__red {
                background-color: $color_secondary;
            }
        }
    }

    .navsocial-mobile {
        height: 40px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        &__linkedin {
            width: 40px;
            height: 40px;
            background-image: url('../assets/images/linkedin.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            margin: 0 15px 0 0;
        }
        &__youtube {
            width: 40px;
            height: 40px;
            background-image: url('../assets/images/youtube.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            margin: 0 15px 0 0;
        }
        &__email {
            width: 49px;
            height: 40px;
            background-image: url('../assets/images/email.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
        }
    }

    .navfooter-mobile {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        &__img {
            height: 36px;
        }
        &__item {
            width: 100%;
            height: 36px;
            margin: 20px 0 0 0;
        }
    }

    .menuDecrease {
        position: fixed;
        background-color: $color_primary;
        width: 100%;
        height: $header-height-mobile;
    }

    .navigation {
        z-index: 100;
        transition: transform 1.5s;
        position: fixed;
        top: 50px;
        padding: 20px 0 200% 0;
        width: 100%;
        transform: translate(-1200px);
        border-radius: 4px;
        font-family: 'Borna-Medium';
        font-size: 21px;
        background-color: $color_primary;
        &--open {
            height: 100%;
            overflow-y: scroll;
            overscroll-behavior-y: contain;
            transition: transform 0.8s;
            transform: translateX(0px);
        }
    }

    .menu {
        margin: 20px 0px 20px 20px;
        list-style-type: none;
        &__item {
            padding: 0 0 12px 0;
        }
        &__spacer {
            background-color: $color_white;
            border: 1px solid $color_black;
            border-radius: 50%;
            height: 6px;
            width: 6px;
            padding: 0 0 0 0;
            margin: 0px 0px 0px 20px;
            white-space: nowrap;
        }
    }

    @include medium {
        .navigation {
            transform: translateX(-1024px);
            &--open {
                transform: translateX(0px);
            }
        }
    }

    @include large {
        .burger {
            display: none;
        }
        .burger2 {
            display: none;
        }

        .navleft {
            position: relative;
            margin: 0 0 0 30px;
        }

		.logo {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            width: 100%;
            cursor: pointer;
            &__img {
                height: $header-logo;
            }
            &__opacity {
                opacity: 0.75;
            }
        }

        .title {
            font-size: 2.2vw;
            &__text {
                cursor: pointer;
                margin: 0 0 0 20px;
                &__opacity {
                    opacity: 0.75;
                }
            }
        }

		$decrease: -140px; //-$header-logo;

		.menuDecrease {
            position: fixed;
            border-bottom: 1px solid $color_black;
			width: 100%;
            height: $header-height;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            color: $color_black;
            transition: transform 1s;
            top: 0px;
            left: 0px;
            &__decrease {
                transform: translateY($decrease);
            }
		}

        .navigation {
            z-index: 100;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            position: initial;
            padding: 0 0 0 0;
            margin: 0 30px 0 0;
            width: 100%;
            max-width: 100%;
            transform: none;
            border-radius: 0px;
            font-family: 'Borna-Medium';
            font-size: 1.2vw;
			width: 100%;
			height: $header-nav;
        }

        .menu {
            padding: 0 10px 0 10px;
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            align-items: flex-end;
            margin: 0 0 0 0;
            &:hover .subMenu {
                display: block;
                &--clicked {
                    display: none;
                }
            }
            &__last {
                padding: 0 0 0 10px;
            }
            &__item {
                padding: 0 0 0 0;
                position: relative;
                white-space: nowrap;
                cursor: pointer;
                &:hover {
                    text-decoration: underline;
                }
                &__selected {
                    text-decoration: underline;
                }
            }
            &__spacer {
                margin: 2px 0 0 0;
            }
        }

        .navmobile {
            display: none;
        }

        .navbottom-mobile {
            display: none;
        }

        .navsocial-mobile {
            display: none;
        }

        .navfooter-mobile {
            display: none;
        }

        .navbottom {
            position: absolute;
            bottom: -15px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-family: 'Borna-Medium';
            font-size: 13px;
            height: 30px;
            text-wrap: nowrap;
            z-index: 1000;
            &__link {
                text-decoration: none;
                color: black;
            }
            &__square {
                height: 30px;
                cursor: pointer;
                padding: 0px 10px 0px 10px;
                margin: 0 15px 0 0;
                background-color: $color_white;
                border: 1px solid $color_black;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                &:hover {
                    background-color: $color_primary;
                }
                &__decrease {
                    // background-color: $color_secondary;
                }
            }
            &__round {
                height: 30px;
                border-radius: 15px; // 1/2 height
                cursor: pointer;
                padding: 0px 10px 0px 10px;
                margin: 0 15px 0 0;
                background-color: $color_white;
                border: 1px solid $color_black;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                &:hover {
                    background-color: $color_primary;
                }
                &__red {
                    background-color: $color_secondary;
                }
            }
        }

        .navsocial {
            position: absolute;
            bottom: -15px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            &__img {
                opacity: 0;
                height: 30px;
            }
            &__contacts {
                display: flex;
                flex-direction: column;
                justify-content: center;
                background-image: url('../assets/images/btn_contacts.svg');
                background-repeat: no-repeat;
                margin: 0 15px 0 0;
                cursor: pointer;
                &:hover {
                    background-image: url('../assets/images/btn_contacts_hover.svg');
                }
            }
            &__linkedin {
                width: 30px;
                height: 30px;
                cursor: pointer;
                background-image: url('../assets/images/linkedin.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                margin: 0 15px 0 0;
                &:hover {
                    background-image: url('../assets/images/linkedin_hover.svg');
                }
            }
            &__youtube {
                width: 30px;
                height: 30px;
                cursor: pointer;
                background-image: url('../assets/images/youtube.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                margin: 0 15px 0 0;
                &:hover {
                    background-image: url('../assets/images/youtube_hover.svg');
                }
            }
            &__email {
                width: 36px;
                height: 30px;
                cursor: pointer;
                background-image: url('../assets/images/email.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                &:hover {
                    background-image: url('../assets/images/email_hover.svg');
                }
            }
        }
    }

    @include xlarge {

        .title {
            font-size: 31px;
        }

        .navigation {
            font-size: 19px;
        }

    }

</style>


<svelte:window on:scroll={expandDecrease} on:popstate|preventDefault={historyNavigation} />
<div id="id_burger" class="burger2" on:click={burgerToggle} on:keydown={burgerToggle}>
	<div class="{isOpenBurger ? 'burger2__lineTop--open' : 'burger2__lineTop'}"></div>
	<div class="{isOpenBurger ? 'burger2__lineBottom--open' : 'burger2__lineBottom'}"></div>
</div>

<div class="menuDecrease" class:menuDecrease__decrease={decreaseMenu} >
    <div class="navleft">
        <div class="logo"  class:logo__opacity={isHoverLogoTitle} 
            on:click={() => redirectTo(idPageHome)} 
            on:keydown={() => redirectTo(idPageHome)} 
            on:mouseover={() => toggleHoverLogoTitle()} 
            on:focus={() => toggleHoverLogoTitle()} 
            on:mouseout={() => toggleHoverLogoTitle()}
            on:blur={() => toggleHoverLogoTitle()} >
            <img class="logo__img" src="../assets/images/logo.svg" alt="logo">
        </div>
        <div class="title">
            <div class="title__text" class:title__text__opacity={isHoverLogoTitle} 
                on:click={() => clickTitle()} 
                on:keydown={() => clickTitle()}
                on:mouseover={() => toggleHoverLogoTitle()} 
                on:focus={() => toggleHoverLogoTitle()} 
                on:mouseout={() => toggleHoverLogoTitle()}
                on:blur={() => toggleHoverLogoTitle()} >    
                le&nbsp;dispositif&nbsp;national&nbsp;de&nbsp;soutien&nbsp;des&nbsp;PTCE
            </div>
            <div class="navbottom">
                <div class="navbottom__square" class:navbottom__square__decrease={decreaseMenu} on:click={openCarto} on:keydown={openCarto}>cartographie des PTCE</div>
                <div class="navbottom__round" on:click={() => redirectTo(idPageProjets)} on:keydown={() => redirectTo(idPageProjets)}>découverte des projets</div>
                <div class="navbottom__square" on:click={() => redirectTo(idPageCharte)} on:keydown={() => redirectTo(idPageCharte)}>charte des PTCE</div>
            </div>
        </div>
    </div>
	<nav class="{isOpenBurger ? 'navigation navigation--open' : 'navigation'}" on:click={burgerToggle} on:keydown={burgerToggle}>
		<div class="menu">
            <div class="menu__item" class:menu__item__selected={$storeCurRoute == idPageDecouvrir} on:click={() => redirectTo(idPageDecouvrir)} on:keydown={() => redirectTo(idPageDecouvrir)}>
                {namePageDecouvrir}
            </div>
		</div>
		<div class="menu__spacer">&nbsp;</div>
		<div class="menu">
            <div class="menu__item" class:menu__item__selected={$storeCurRoute == idPageAccompagner} on:click={() => redirectTo(idPageAccompagner)} on:keydown={() => redirectTo(idPageAccompagner)}>
                {namePageAccompagner}
            </div>
		</div>
		<div class="menu__spacer">&nbsp;</div>
		<div class="menu menu__last">
            <div class="menu__item" class:menu__item__selected={$storeCurRoute == idPageActualites} on:click={() => redirectTo(idPageActualites)} on:keydown={() => redirectTo(idPageActualites)}>
                {namePageActualites}
            </div>
            <div class="navsocial">
                <div class="navsocial__contacts" on:click={() => redirectTo(idPageContacts)} on:keydown={() => redirectTo(idPageContacts)}>
                    <img class="navsocial__img" src="../assets/images/btn_contacts.svg" alt="contacts">
                </div>
        
                <a href="http://www.linkedin.com/company/info-ptce" target="_blank"><div class="navsocial__linkedin"></div></a>
                <a href="http://www.youtube.com/@info-ptce" target="_blank"><div class="navsocial__youtube"></div></a>
                <a href="mailto:ptce@coorace.org" target="_blank"><div class="navsocial__email"></div></a>
            </div>
        </div>
        <div class="navmobile">
            <div class="navbottom-mobile">
                <div class="navbottom-mobile__square" on:click={openCarto} on:keydown={openCarto}>cartographie des PTCE</div>
                <div class="navbottom-mobile__round" on:click={() => redirectTo(idPageProjets)} on:keydown={() => redirectTo(idPageProjets)}>découverte des projets</div>
                <div class="navbottom-mobile__square" on:click={() => redirectTo(idPageCharte)} on:keydown={() => redirectTo(idPageCharte)}>charte des PTCE</div>
            </div>
            <div class="navsocial-mobile">
                <div class="navsocial-mobile__linkedin"></div>
                <div class="navsocial-mobile__youtube"></div>
                <div class="navsocial-mobile__email"></div>
            </div>    
            <div class="navfooter-mobile">
                <div class="navfooter-mobile__item navfooter-mobile__mentions" on:click={() => redirectTo(idPageMentionsLegales)} on:keydown={() => redirectTo(idPageMentionsLegales)}>
                    <img class="navfooter-mobile__img" src="../assets/images/btn_mentions_legales.svg" alt="mentions léglales">
                </div>
                <div class="navfooter-mobile__item navfooter-mobile__contacts" on:click={() => redirectTo(idPageContacts)} on:keydown={() => redirectTo(idPageContacts)}>
                    <img class="navfooter-mobile__img" src="../assets/images/btn_contacts.svg" alt="contacts">
                </div>
            </div>
        </div>
    </nav>
</div>